import './blog-overview.scss';
import Swiper from '../../vendor/swiper/swiper';

class BlogOverview {
    constructor ($overview) {
        this.$blogSlider = $overview;
        this.$slider = this.$blogSlider.querySelector('[data-blog-slider="slider"]');
        this.sliderCount = this.$slider.getAttribute('data-slider-count');
        this.$slidePrev = this.$blogSlider.querySelector('[data-blog-slider="prev"]');
        this.$slideNext = this.$blogSlider.querySelector('[data-blog-slider="next"]');

        this.slider = null;
    }

    initialize () {
        this.checkSize();
        // this.setEvents();
    }

    checkSize () {
        if (window.innerWidth < 1024 && this.sliderCount >= 2) {
            if (this.slider === null) {
                this.initSlider();
            }
        }

        window.resizeHandler.customFunctions.push(() => {
            if (window.innerWidth < 1024 && this.sliderCount >= 2) {
                if (this.slider === null) {
                    this.initSlider();
                }
            } else {
                this.destroySlider();
            }
        });
    }

    initSlider () {
        this.slider = new Swiper(this.$blogSlider, {
            slidesPerView: 1,
            spaceBetween: 20,
            speed: 500,
            breakpointsInverse: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },
            navigation: {
                prevEl: this.$slidePrev,
                nextEl: this.$slideNext
            },
            breakpoints: {
                768: {
                    slidesPerView: 2
                }
            }
        });

        this.$slidePrev.addEventListener('click', () => {
            this.slider.slidePrev();
        });

        this.$slideNext.addEventListener('click', () => {
            this.slider.slideNext();
        });
    }

    destroySlider () {
        if (this.slider !== null) {
            console.log('destroy');
            this.slider.destroy(true, true);
            this.slider = null;
        }
    }
}

export { BlogOverview };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    const $blogOverview = $context.querySelector('[data-blog-slider="root"]');

    if ($blogOverview) {
        const blogOverview = new BlogOverview($blogOverview);
        blogOverview.initialize();
    }
});
